{{#if config.label}}
  {{> elements/_page_builder_label label=config.label description=config.description }}
{{/if}}
<div class="tool-field video-editor{{#unless context.poster_image_path}} placeholder{{/unless}}">
  <img src="{{#if context.poster_image_path}}{{context.poster_image_path}}{{else}}/assets/admin/placeholders/video-empty-b516cea0.svg{{/if}}"class="video-preview preview">
</div>
